// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BindingExpiration, BindingExpirationSchema } from 'api/gen/BindingExpiration';

const requiredPart = t.interface({
  bindingExpiration: BindingExpirationSchema,
  roleId: t.Integer,
  userProfileOtherSubjectRoleId: t.Integer,
});

export const OtherSubjectRoleManagementSchema = excess(requiredPart);

export interface OtherSubjectRoleManagement extends t.TypeOf<typeof OtherSubjectRoleManagementSchema> {}
